import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-self-employee-details',
  templateUrl: './self-employee-details.component.html',
  styleUrls: ['./self-employee-details.component.scss'],
})
export class SelfEmployeeDetailsComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;

  claimId: any;
  isLoading: boolean = false;
  commonToggleList = [
    {
      label: 'label.common.yes',
      value: 'Y',
    },
    {
      label: 'label.common.no',
      value: 'N',
    },
  ];
  selecteToggle: string = 'N';
  occupationUrl: any;
  occupationModule: any;

  constructor(
    private commonService: CommonService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<SelfEmployeeDetailsComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  async ngOnInit(): Promise<void> {
    this.claimId = this.data.claimID;
    this.occupationUrl = this.data.occupationUrl;
    console.log('occupationUrl', this.occupationUrl);
    await this.getOccupationById();
  }

  async getOccupationById() {
    this.isLoading = true;
    try {
      let url = this.occupationUrl;
      let getOccupationResponse = await this.commonService.commonGet(url);
      this.occupationModule = getOccupationResponse.body;
      this.isLoading = false;
    } catch (error) {
      console.log('Get Claim disability By Id Failed', error);
      this.isLoading = false;
    }
  }

  onChangeValue(event, key) {
    console.log(event, key);
  }
  async onCloseDialog() {
    this.dialogRef.close();
  }
}
